import { useLazyQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { useCallback } from 'react';
import { Queries } from '@shared/api';

type GetChannelFunction = (
  params: MBAPI.ChannelQueryVariables,
) => Promise<MBAPI.ChannelDetailsQuery_channel | undefined>;

export function useGetChannelLazyQuery(): GetChannelFunction {
  const [getChannel] = useLazyQuery<MBAPI.ChannelDetailsQuery, MBAPI.ChannelQueryVariables>(
    Queries.channel.getChannel,
  );
  return useCallback<GetChannelFunction>(
    async ({ id, slug }: MBAPI.ChannelQueryVariables) => {
      if (!isNil(id) || !isNil(slug)) {
        const response = await getChannel({ variables: { id, slug } });
        return response.data?.channel ?? undefined;
      }
    },
    [getChannel],
  );
}
